"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var shapes_base_1 = require("./shapes-base");

var config_1 = require("./config");

var utils_1 = require("./utils");

var lodash_1 = require("lodash");

var translations_1 = __importDefault(require("./translations"));

exports.createTopShapes = function (plateComponents, canvas) {
  var shapes = [];
  var wallShapes = createWallShapes(plateComponents.elements.concat(plateComponents.additional), plateComponents.plate);
  shapes.push(wallShapes);
  var plateShapes = createPlateShapes(plateComponents.elements.concat(plateComponents.additional), plateComponents.plate, canvas);
  shapes.push(plateShapes);
  var elementShapes = createElementShapes(plateComponents.elements.concat(plateComponents.additional), plateComponents.plate, canvas);
  shapes.push(elementShapes);
  return shapes;
};

var createWallShapes = function createWallShapes(elements, plate) {
  var shapes = []; // Left Wall

  var leftWallElement = elements.find(function (e) {
    return e.type === 'wall' && e.isFirst;
  });

  if (leftWallElement) {
    var x = plate.nsides.left;
    var y1 = plate.nsides.bottom + 40;
    var y2 = plate.nsides.top;
    shapes.push(shapes_base_1.createVerticalWall(x, y1, x, y2, 'left'));
  } // Right wall


  var rightWallElement = elements.find(function (e) {
    return e.type === 'wall' && e.isLast;
  });

  if (rightWallElement) {
    var x = plate.nsides.right;
    var y1 = plate.nsides.bottom + 40;
    var y2 = plate.nsides.top;
    shapes.push(shapes_base_1.createVerticalWall(x, y1, x, y2, 'right'));
  } // Top wall


  if (plate.nscale.x > 0) {
    var x1 = plate.nsides.left;
    var x2 = plate.nsides.right;
    var y = plate.nsides.top;
    var hasLeft = typeof leftWallElement !== 'undefined';
    var hasRight = typeof rightWallElement !== 'undefined';
    shapes.push(shapes_base_1.createHorizontalWall(x1, y, x2, y, 'top', hasLeft, hasRight));
  }

  return shapes;
};

var createPlateShapes = function createPlateShapes(elements, plate, canvas) {
  var shapes = []; // Outline

  if (plate.nscale.x > 0) {
    var x = plate.nsides.left;
    var y = plate.nsides.top;
    var width = plate.nscale.x;
    var height = plate.nscale.y;
    shapes.push(shapes_base_1.createRect(x, y, width, height));
  } // Horizontal scale top


  if (plate.nscale.x > 0) {
    var y = config_1.config.text.space;
    var x1 = plate.nsides.left;
    var x2 = plate.nsides.right;
    shapes.push(shapes_base_1.createMeasurementLine(x1, y, x2, y));
    shapes.push(shapes_base_1.createText(utils_1.getCenter(x1, x2), y, plate.scale.x));
  } // Horizontal scale bottom


  if (plate.nscale.x > 0) {
    var y = canvas.scale.y - utils_1.calculateStep(0) - config_1.config.lines.space;
    var x1 = plate.nsides.left;
    var x2 = plate.nsides.right;
    var total = parseInt(plate.scale.x); // Add angles

    var leftWall = elements.find(function (e) {
      return e.type === 'wall' && e.isFirst;
    });
    var leftAngle = leftWall && leftWall.rotate.y - 90;
    var rightWall = elements.find(function (e) {
      return e.type === 'wall' && e.isLast;
    });
    var rightAngle = rightWall && rightWall.rotate.y - 90;

    if (leftAngle) {
      var leftSide = Math.sin(utils_1.toRadians(leftAngle)) * plate.scale.y;
      total = total + leftSide;
    }

    if (rightAngle) {
      var rightSide = Math.sin(utils_1.toRadians(rightAngle)) * plate.scale.y;
      total = total + rightSide;
    }

    total = parseFloat(total.toFixed(1));
    shapes.push(shapes_base_1.createMeasurementLine(x1, y, x2, y));
    shapes.push(shapes_base_1.createText(utils_1.getCenter(x1, x2), y, '(' + total + ')'));
  } // Horizontal top/bottom lines
  // if (plate.nscale.y > 0) {
  //   const x1 = 0;
  //   const x2 = plate.nsides.left;
  //   shapes.push(createLine(x1, plate.nsides.top, x2, plate.nsides.top)); // Above line
  //   shapes.push(createLine(x1, plate.nsides.bottom, x2, plate.nsides.bottom)); // Below line
  // }
  // Vertical scale
  // if (plate.nscale.x > 0) {
  //   const x = config.text.space;
  //   const y1 = plate.nsides.bottom;
  //   const y2 = plate.nsides.top;
  //   const scale = plate.scale.y;
  //   shapes.push(createMeasurementLine(x, y1, x, y2, true, scale < 100));
  //   shapes.push(createText(x, getCenter(y1, y2), scale, true));
  // }


  return shapes;
};

var createElementShapes = function createElementShapes(elements, plate, canvas, parent) {
  var shapes = [];
  shapes.push(troughs(elements, plate, canvas));
  shapes.push(apron(elements, plate));
  shapes.push(cornerRadius(elements, plate)); // Vertical left/right lines... should be part of the plate function, but I need the left & right lines to be above the corner radius...

  if (plate.nscale.x > 0) {
    var y1 = canvas.scale.y - utils_1.calculateStep(0);
    var y2 = utils_1.calculateStep(0);
    shapes.push(shapes_base_1.createLine(plate.nsides.left, y1, plate.nsides.left, y2)); // Left line

    shapes.push(shapes_base_1.createLine(plate.nsides.right, y1, plate.nsides.right, y2)); // Right line
  }

  elements.forEach(function (element, index) {
    var nextElements = elements.slice(index + 1, elements.length) || []; // Draw center lines for all important elements

    if (config_1.config.top.centerLines.includes(element.type)) {
      var x = element.nposition.x;
      var y1 = 0;
      var y2 = plate.nposition.y; // Add extra space if trough

      if (element.type === 'trough') {
        y1 = utils_1.calculateStep(1);
        y2 = element.nposition.y;
      } // Add extra space if cut-out


      if (element.type === 'cut-out') {
        y1 = utils_1.calculateStep(2);
        y2 = element.nposition.y;
      } // Add extra space if sd/tap


      if (element.type === 'tap' || element.type === 'soap-dispenser') {
        y1 = utils_1.calculateStep(3);
        y2 = plate.nsides.top;
      }

      shapes.push(shapes_base_1.createLine(x, y1, x, y2));
    } // Horizontal measurement line for trough - trough


    if (element.type === 'wall' || element.type === 'edge' || element.type === 'trough') {
      var nextTrough = lodash_1.filter(nextElements, function (e) {
        return e.type === 'trough' || e.type === 'wall' || e.type === 'edge';
      })[0];

      if (nextTrough) {
        var y = utils_1.calculateStep(1, true);
        var x1 = element.nposition.x;
        var x2 = nextTrough.nposition.x;
        var text = nextTrough.position.x - element.position.x;

        if (element.isLast) {
          text = Math.ceil(text);
          text = '(' + text + ')';
        }

        shapes.push(shapes_base_1.createMeasurementLine(x1, y, x2, y));
        shapes.push(shapes_base_1.createText(utils_1.getCenter(x1, x2), y, text));
      }
    } // Console


    if (element.type === 'console') {
      var x = element.nsides.left;
      var y = element.nposition.y;
      var width = element.nscale.x;
      var height = element.nscale.y;

      if (element.fileName === 'uhalter_miranit') {
        shapes.push(shapes_base_1.createImage(x, y, width, height, "https://kwcws3d.blob.core.windows.net/cdn/wireframes/" + element.fileName + "_top.svg", true));
      } else {
        shapes.push(shapes_base_1.createRect(x, y, width, height, true));
      }
    } // Angle bar


    if (element.type === 'angle-bar') {
      // Outline
      {
        var x = element.isFirst ? element.nposition.x : element.nposition.x - element.nscale.x;
        var y = element.nsides.top;
        var width = element.nscale.x;
        var height = element.nscale.y;
        shapes.push(shapes_base_1.createRect(x, y, width, height, true));
      } // Horizontal top/bottom lines

      {
        var x1 = element.nsides.left;
        var x2 = plate.nsides.right + utils_1.calculateStep(2, true);
        shapes.push(shapes_base_1.createLine(x1, plate.nsides.top, x2, plate.nsides.top)); // Above line

        shapes.push(shapes_base_1.createLine(x1, element.nsides.top, x2, element.nsides.top)); // Below line
      } // Vertical scale

      {
        var x = plate.nsides.right + utils_1.calculateStep(2);
        var y1 = element.nsides.top;
        var y2 = plate.nsides.top;
        var scale = element.sides.top - plate.sides.top;
        shapes.push(shapes_base_1.createMeasurementLine(x, y1, x, y2, true, scale < 100));
        shapes.push(shapes_base_1.createText(x, utils_1.getCenter(y1, y2), scale, true));
      } // Text

      {
        var allAnglebars = lodash_1.filter(elements, function (e) {
          return e.type === 'angle-bar';
        });
        var textLines = [allAnglebars.length + 'x ' + translations_1.default.translate('Part.AngleBar')];
        var x1 = element.nposition.x;
        var y1 = element.nposition.y;

        if (element.materialName === 'stainlessSteelWhite') {
          textLines.push('2030051364');
        } else {
          textLines.push('2000105048');
        }

        shapes.push(shapes_base_1.createExplodedText(x1, y1, plate.nsides.right + utils_1.calculateStep(2) - 10, plate.nsides.top + 50, textLines, 'right'));
      }
    } // Surge edge


    if (element.type === 'surge-edge') {
      var x = element.nsides.left;
      var y = element.nsides.top;
      var width = element.nscale.x;
      var height = element.nscale.y;
      shapes.push(shapes_base_1.createRect(x, y, width, height));
    } // Child elements...


    if (typeof element.elements !== 'undefined') {
      shapes.push(createElementShapes(element.elements, plate, canvas, element));
    }
  });
  shapes.push(tapHoles(elements, plate, canvas, parent));
  shapes.push(safetyCatches(elements, plate));
  shapes.push(cutOuts(elements, plate, canvas));
  shapes.push(angleOfNiches(elements));
  return shapes;
};

var troughs = function troughs(elements, plate, canvas) {
  var shapes = [];
  elements.forEach(function (element, index) {
    if (element.type !== 'trough') {
      return;
    }

    var prevElements = elements.slice(0, index).reverse() || [];
    var nextElement = elements[index + 1];
    var nextElements = elements.slice(index + 1, elements.length) || [];
    var nextElementsUntilTrough = utils_1.splitElementsAtTypes(['trough'], nextElements); // Medcare cover

    {} // Outline

    {
      var x = element.nsides.left;
      var y = element.nsides.top;
      var width = element.nscale.x;
      var height = element.nscale.y; // RWT has a weird outline, so have to cover up shit... I did try to be smarter about this but aghhh I give up!

      if (element.fileName === 'VARIUSmed_RWT' || element.fileName.includes('MEDCARE')) {
        shapes.push(shapes_base_1.createRect(x + 2, y + 2, width - 4, height, false, 'white', 'white', 0));
      }

      console.log("elem", element);
      shapes.push(shapes_base_1.createImage(x, y, width, height, "https://kwcws3d.blob.core.windows.net/cdn/wireframes/" + element.fileName + "_top.svg", true));
    } // Horizontal measurement line for trough - cutouts

    var nextCutout = lodash_1.filter(nextElementsUntilTrough, function (e) {
      return e.type === 'cut-out';
    })[0];

    if (nextCutout) {
      var y = utils_1.calculateStep(2, true);
      var x1 = element.nposition.x;
      var x2 = nextCutout.nposition.x;
      shapes.push(shapes_base_1.createMeasurementLine(x1, y, x2, y));
      shapes.push(shapes_base_1.createText(utils_1.getCenter(x1, x2), y, nextCutout.position.x - element.position.x));
    } // Horizontal measurement line for trough - previous cutouts


    if (element.isFirst) {
      var prevCutout = lodash_1.filter(prevElements, function (e) {
        return e.type === 'cut-out';
      })[0];

      if (prevCutout) {
        var y = utils_1.calculateStep(2, true);
        var x1 = prevCutout.nposition.x;
        var x2 = element.nposition.x;
        shapes.push(shapes_base_1.createMeasurementLine(x1, y, x2, y));
        shapes.push(shapes_base_1.createText(utils_1.getCenter(x1, x2), y, Math.abs(element.position.x - prevCutout.position.x)));
      }
    } // Horizontal measurement line for trough - tap


    if (nextElement.type === 'tap' || nextElement.type === 'soap-dispenser') {
      var y = utils_1.calculateStep(3, true);
      var x1 = element.nposition.x;
      var x2 = nextElement.nposition.x;
      shapes.push(shapes_base_1.createMeasurementLine(x1, y, x2, y));
      shapes.push(shapes_base_1.createText(utils_1.getCenter(x1, x2), y, Math.abs(nextElement.position.x - element.position.x)));
    }

    if (element.isFirst && plate.nsides.top !== element.nsides.top) {
      // Horizontal top/bottom line
      {
        var x1 = plate.nsides.left - utils_1.calculateStep(4, true);
        var x2 = element.nposition.x;
        shapes.push(shapes_base_1.createLine(x1, plate.nsides.top, x2, plate.nsides.top));
        shapes.push(shapes_base_1.createLine(x1, element.nsides.top, x2, element.nsides.top)); // shapes.push(createLine(element.nsides.left, element.nsides.bottom, element.nsides.right, element.nsides.bottom));
      } // Vertical measurement for trough position

      if (element.sides.top !== 0) {
        var x = plate.nsides.left - utils_1.calculateStep(4);
        var y1 = element.nsides.top;
        var y2 = plate.nsides.top;
        shapes.push(shapes_base_1.createMeasurementLine(x, y1, x, y2, true, true));
        shapes.push(shapes_base_1.createText(x, utils_1.getCenter(y1, y2), element.sides.top, true));
      }
      /*
      // Vertical measurement for inner scale
      {
        const x = element.nsides.left + config.text.space;
        const y1 = element.nsides.bottom;
        const y2 = element.nsides.top;
               shapes.push(createMeasurementLine(x, y1, x, y2, true)); // Right inner of trough
        shapes.push(createText(x , getCenter(y1, y2), element.scale.y, true));
      }
      // Vertical left/right lines
      {
        const y1 = plate.nsides.top; // Back of plate...
        const y2 = canvas.scale.y - calculateStep(1);
               shapes.push(createLine(element.nsides.left, y1, element.nsides.left, y2)); // Left of trough
        shapes.push(createLine(element.nsides.right, y1, element.nsides.right, y2)); // Right of trough
      }
      // Horizontal measurement line for scale
      {
        const y = canvas.scale.y - calculateStep(1) - config.lines.space;
        const x1 = element.nsides.left;
        const x2 = element.nsides.right;
               shapes.push(createMeasurementLine(x1, y, x2, y));
        shapes.push(createText(getCenter(x1, x2), y, element.scale.x));
      }
      */

    } // Drain


    var drain = element.elements.find(function (e) {
      return e.type === 'drain';
    });

    if (drain) {
      var x = drain.nsides.left;
      var y = drain.nsides.top;
      shapes.push(shapes_base_1.createCrosshair(x, y, drain.nscale.x, drain.nscale.y));
    } else {
      var x = element.nposition.x - 5;
      var y = element.nposition.y - 5;
      shapes.push(shapes_base_1.createCrosshair(x, y, 10, 10));
    }
  });
  return shapes;
};

var cornerRadius = function cornerRadius(elements, plate) {
  var shapes = [];
  var hasApronLeft = elements.find(function (e) {
    return e.type === 'apron' && e.isFirst;
  });
  var hasApronRight = elements.find(function (e) {
    return e.type === 'apron' && e.isLast;
  });
  elements.forEach(function (element) {
    if (element.type !== 'corner-radius') {
      return;
    }

    var x = element.nposition.x;
    var y = element.nposition.y;
    var width = element.nscale.x;
    var rotate = element.rotate && element.rotate.y || 0;
    var side = element.isLast ? 'right' : 'left';
    var strokeWidth = config_1.config.shapes.strokeWidth; // Background to basically remove the apron lines... have to account for strokeWidth stuff

    var backX = x - (side === 'right' ? 0 : width) - strokeWidth / 2;
    var backY = y - strokeWidth / 2;
    var backWidth = width + config_1.config.shapes.strokeWidth;
    var backHeight = width + config_1.config.shapes.strokeWidth;
    shapes.push(shapes_base_1.createRect(backX, backY, backWidth, backHeight, false, 'white', 'white', 0));
    var text = '';

    if (element.shape === 'radius') {
      var arcX = x + (side === 'right' ? -(strokeWidth / 2) : strokeWidth / 2);
      var arcY = y - strokeWidth / 2;
      var arcWidth = width;
      var arcStart = 180 + rotate;
      var arcEnd = 270 + rotate;
      text = 'R100';
      shapes.push(shapes_base_1.createArc(arcX, arcY, arcWidth, arcStart, arcEnd, config_1.config.shapes.strokeWidth, config_1.config.shapes.strokeColor));

      if (side === 'right' && hasApronRight) {
        shapes.push(shapes_base_1.createArc(arcX - 1.5, arcY - 1.5, arcWidth, arcStart, arcEnd, 1, config_1.config.shapes.strokeColor, true));
      }

      if (side === 'left' && hasApronLeft) {
        shapes.push(shapes_base_1.createArc(arcX + 1.5, arcY - 1.5, arcWidth, arcStart, arcEnd, 1, config_1.config.shapes.strokeColor, true));
      }
    } else {
      var lineX1 = x + (side === 'right' ? width - strokeWidth / 2 : strokeWidth / 2 - width);
      var lineY1 = y - strokeWidth / 2;
      var lineX2 = x + (side === 'right' ? -(strokeWidth / 2) : strokeWidth / 2);
      var lineY2 = y + element.nscale.y - strokeWidth / 2;
      text = '100 x 45°';
      shapes.push(shapes_base_1.createLine(lineX1, lineY1, lineX2, lineY2, config_1.config.shapes.strokeWidth, config_1.config.shapes.strokeColor, false));

      if (side === 'right' && hasApronRight) {
        shapes.push(shapes_base_1.createLine(lineX1 - 1.5, lineY1 - 1.5, lineX2 - 1.5, lineY2 - 1.5, 1, config_1.config.shapes.strokeColor, false, true));
      }

      if (side === 'left' && hasApronLeft) {
        shapes.push(shapes_base_1.createLine(lineX1 + 1.5, lineY1 - 1.5, lineX2 + 1.5, lineY2 - 1.5, 1, config_1.config.shapes.strokeColor, false, true));
      }
    } // Exploded text


    var posAdjust = element.shape === 'radius' ? width * 0.7 : width * 0.5;
    var textPointX = side === 'right' ? x + posAdjust : x - posAdjust;
    var textPointY = y + posAdjust;
    var textCopyX = side === 'right' ? plate.nsides.right + config_1.config.explodedTextSpace : plate.nsides.left - config_1.config.explodedTextSpace;
    var textCopyY = plate.nsides.bottom - 16;
    shapes.push(shapes_base_1.createExplodedText(textPointX, textPointY, textCopyX, textCopyY, [text], side));
  });
  return shapes;
};

var apron = function apron(elements, plate) {
  var shapes = [];
  var hasApronLeft = elements.find(function (e) {
    return e.type === 'apron' && e.isFirst;
  });
  var hasApronRight = elements.find(function (e) {
    return e.type === 'apron' && e.isLast;
  });
  elements.forEach(function (element) {
    if (element.type === 'apron') {
      var x = element.nsides.left;
      var y = element.nsides.top;
      var width = element.nscale.x;
      var height = element.nscale.y;
      shapes.push(shapes_base_1.createRect(x, y, width, height, true, undefined, undefined, 1)); // Exploded text... for front apron only

      if (!element.isFirst && !element.isLast) {
        // Exploded text
        var textPointX = element.nsides.left + 40;
        var textPointY = element.nposition.y;
        var textCopyX = plate.nsides.left - config_1.config.explodedTextSpace;
        var textCopyY = plate.nsides.bottom + 30;
        var textLines = [];
        var line1 = translations_1.default.translate('Part.apron');

        if (hasApronLeft) {
          line1 = line1 + ' ' + translations_1.default.translate('Detail.Left') + ' +';
        }

        textLines.push(line1);
        var line2 = translations_1.default.translate('Detail.front');

        if (hasApronRight) {
          line2 = line2 + ' + ' + translations_1.default.translate('Detail.Right');
        }

        textLines.push(line2);
        shapes.push(shapes_base_1.createExplodedText(textPointX, textPointY, textCopyX, textCopyY, textLines, 'left'));
      }
    }
  });
  return shapes;
};

var safetyCatches = function safetyCatches(elements, plate) {
  var shapes = [];
  elements.forEach(function (element) {
    if (element.type !== 'safety-catch') {
      return;
    } // Outline


    {
      var x = element.nsides.left;
      var y = element.nposition.y - element.nscale.x;
      var width = element.nscale.x;
      var height = element.nscale.y;
      shapes.push(shapes_base_1.createRect(x, y, width, height, true));
    } // Vertical line

    {
      var x = element.nposition.x;
      var y1 = utils_1.calculateStep(6);
      var y2 = element.nposition.y + 5;
      shapes.push(shapes_base_1.createLine(x, y1, x, y2));
    } // Horizontal measurement line for all safety-catch

    {
      var y = utils_1.calculateStep(6, true);
      var x1 = 0;
      var x2 = 0;
      var distance = 0;

      if (element.isFirst) {
        x1 = plate.nsides.left;
        x2 = element.nposition.x;
        distance = element.position.x - plate.sides.left;
      } else {
        x1 = element.nposition.x;
        x2 = plate.nsides.right;
        distance = plate.sides.right - element.position.x;
      }

      shapes.push(shapes_base_1.createMeasurementLine(x1, y, x2, y, false, true));
      shapes.push(shapes_base_1.createText(utils_1.getCenter(x1, x2), y, distance));
    } // Exploded text for last

    if (element.isLast) {
      var x1 = element.nposition.x;
      var y1 = element.nposition.y - element.nscale.x;
      var x2 = plate.nsides.right + config_1.config.explodedTextSpace;
      var y2 = plate.nsides.top - 80;
      var textLines = [translations_1.default.translate('Part.TriggerSafety')]; // TODO - Add rotated arrow

      if (element.materialName === 'stainlessSteelWhite') {
        textLines.push('2030051369');
      } else {
        textLines.push('2000105062');
      }

      textLines.push(translations_1.default.translate('Part.SocketM6'));
      shapes.push(shapes_base_1.createExplodedText(x1, y1, x2, y2, textLines));
    }
  });
  return shapes;
};

var tapHoles = function tapHoles(elements, plate, canvas, parent) {
  var shapes = [];
  elements.forEach(function (element, index) {
    if (element.type !== 'tap' && element.type !== 'soap-dispenser') {
      return;
    }

    var prevElement = elements[index - 1];
    var nextElement = elements[index + 1]; // Outline

    {
      var x = element.nsides.left;
      var y = element.nsides.top;
      var width = element.nscale.x;
      var height = element.nscale.y;
      shapes.push(shapes_base_1.createEllipse(x, y, width, height));
    } // Center

    {
      var size = 10;
      var x = element.nposition.x - size / 2;
      var y = element.nposition.y - size / 2;
      shapes.push(shapes_base_1.createCrosshair(x, y, size, size, false, false));
    } // Tap - trough horizontal measurement lines

    if (nextElement && nextElement.type === 'trough' || parent && parent.type === 'trough') {
      // FIXME... what if a trough is directly after a tap but not part of it?
      var trough = nextElement && nextElement.type === 'trough' && nextElement || parent || prevElement && prevElement.type === 'trough' && prevElement;
      var y = utils_1.calculateStep(3, true);
      var x1 = element.nposition.x;
      var x2 = trough.nposition.x;
      var distance = Math.abs(trough.position.x - element.position.x);

      if (distance > 0) {
        shapes.push(shapes_base_1.createMeasurementLine(x1, y, x2, y, false, true));
        shapes.push(shapes_base_1.createText(utils_1.getCenter(x1, x2), y, distance));
      }
    } // Vertical left/right lines


    {
      var y1 = element.type === 'soap-dispenser' ? utils_1.calculateStep(5) : utils_1.calculateStep(4); // Back of plate...

      var y2 = element.nposition.y;
      shapes.push(shapes_base_1.createLine(element.nsides.left, y1, element.nsides.left, y2));
      shapes.push(shapes_base_1.createLine(element.nsides.right, y1, element.nsides.right, y2));
    } // Horizontal measurement

    {
      var y = element.type === 'soap-dispenser' ? utils_1.calculateStep(5, true) : utils_1.calculateStep(4, true);
      var x1 = element.nsides.left;
      var x2 = element.nsides.right;
      shapes.push(shapes_base_1.createMeasurementLine(x1, y, x2, y, false, true));
      shapes.push(shapes_base_1.createText(utils_1.getCenter(x1, x2), y, 'Ø' + element.scale.x));
    }

    if (element.isFirst) {
      var trough = nextElement && nextElement.type === 'trough' && nextElement || parent || prevElement && prevElement.type === 'trough' && prevElement;
      var isBackwall = trough.subType !== 'backwall';
      var troughEdge = isBackwall ? trough.sides.top : trough.sides.top + trough.buffer.back;
      var nTroughEdge = isBackwall ? trough.nsides.top : trough.nsides.top + trough.nbuffer.back;
      var isTroughEdgeAbove = nTroughEdge <= element.nposition.y; // If trough edge is above the tap position, then we need to do scale from tap to above, otherwise tap to below

      var from = isTroughEdgeAbove ? plate.nsides.top : element.nposition.y;
      var to = isTroughEdgeAbove ? element.nposition.y : nTroughEdge;
      var text = isTroughEdgeAbove ? element.position.y : troughEdge - element.position.y; // Horizontal top/bottom line

      {
        var x1 = plate.nsides.left - (element.type === 'soap-dispenser' ? utils_1.calculateStep(3, true) : utils_1.calculateStep(2, true));
        var x2 = element.nposition.x;
        shapes.push(shapes_base_1.createLine(x1, from, x2, from));
        shapes.push(shapes_base_1.createLine(x1, to, x2, to)); // shapes.push(createLine(x1, plate.nsides.top, x2, plate.nsides.top));
        // shapes.push(createLine(x1, element.nposition.y, x2, element.nposition.y));
      } // Vertical measurement line

      {
        var x = plate.nsides.left - (element.type === 'soap-dispenser' ? utils_1.calculateStep(3) : utils_1.calculateStep(2));
        var y1 = to;
        var y2 = from;
        shapes.push(shapes_base_1.createMeasurementLine(x, y1, x, y2, true, true));
        shapes.push(shapes_base_1.createText(x, utils_1.getCenter(y1, y2), text, true));
      }
    }
  });
  return shapes;
};

var cutOuts = function cutOuts(elements, plate, canvas) {
  var shapes = [];
  var isFirst = true;
  elements.forEach(function (element, index) {
    if (element.type !== 'cut-out') {
      return;
    }

    var hole = element.elements.find(function (e) {
      return e.type === 'cut-out-hole';
    });
    var trash = element.elements.find(function (e) {
      return e.type === 'cut-out-trash';
    });

    if (!hole) {
      return;
    } // Outline


    {
      var x = hole.nsides.left;
      var y = hole.nsides.top;

      if (hole.shape === 'cylinder') {
        shapes.push(shapes_base_1.createEllipse(x, y, hole.nscale.x, hole.nscale.y));
      } else {
        shapes.push(shapes_base_1.createRect(x, y, hole.nscale.x, hole.nscale.y, false, 'transparent'));
      }
    } // Center

    {
      var size = hole.nscale.x / 4;
      var x = hole.nposition.x - size / 2;
      var y = hole.nposition.y - size / 2;
      shapes.push(shapes_base_1.createCrosshair(x, y, size, size, false, false));
    } // Vertical left/right lines for all cut-outs

    {
      var y1 = element.nposition.y;
      var y2 = canvas.scale.y - utils_1.calculateStep(1);
      shapes.push(shapes_base_1.createLine(hole.nsides.left, y1, hole.nsides.left, y2)); // Left of cut-out

      shapes.push(shapes_base_1.createLine(hole.nsides.right, y1, hole.nsides.right, y2)); // Right of cut-out
    } // Horizontal width line for cut-out

    {
      var y = canvas.scale.y - utils_1.calculateStep(1) - config_1.config.lines.space;
      var x1 = hole.nsides.left;
      var x2 = hole.nsides.right;
      var text = hole.shape === 'cylinder' ? 'Ø' : '';
      var textOffset = 'middle';
      var fontSize = config_1.config.text.size.toString();
      var x = utils_1.getCenter(x1, x2);
      text = text + hole.scale.x;

      if (hole.shape !== 'cylinder') {
        var cutOutRemainder = element.positionIndex % 3;
        textOffset = cutOutRemainder === 0 && 'right' || cutOutRemainder === 1 && 'left' || cutOutRemainder === 2 && 'center';
        text = text + ' x ' + hole.scale.y + ' ';
        text = text + translations_1.default.translate('Part.WidthDepth');
        fontSize = '14';
      }

      shapes.push(shapes_base_1.createMeasurementLine(x1, y, x2, y, false, true));
      shapes.push(shapes_base_1.createText(utils_1.getCenter(x1, x2), y, text, false, 'middle', textOffset, fontSize));
    } // Exploded text Gelcoat

    {
      var x1 = hole.nposition.x;
      var y1 = hole.nsides.bottom;
      var x2 = plate.nsides.right + config_1.config.explodedTextSpace;
      var y2 = plate.nsides.bottom + 10;
      var textLines = [translations_1.default.translate('Part.AllSidesCoated'), translations_1.default.translate('Part.WithGelcoat')];
      shapes.push(shapes_base_1.createExplodedText(x1, y1, x2, y2, textLines));
    }

    if (isFirst) {
      isFirst = false; // Horizontal top/bottom line for first cut-out

      {
        var x1 = plate.nsides.right + utils_1.calculateStep(1, true);
        var x2 = element.nposition.x;
        shapes.push(shapes_base_1.createLine(x1, plate.nsides.top, x2, plate.nsides.top));
        shapes.push(shapes_base_1.createLine(x1, element.nposition.y, x2, element.nposition.y));
      } // Vertical measurement

      {
        var x = plate.nsides.right + utils_1.calculateStep(1);
        var y1 = element.nposition.y;
        var y2 = plate.nsides.top;
        shapes.push(shapes_base_1.createMeasurementLine(x, y1, x, y2, true));
        shapes.push(shapes_base_1.createText(x, utils_1.getCenter(y1, y2), element.position.y, true));
      }
      /*
      if (hole.shape !== 'cylinder') {
        // Horizontal top/bottom line
        {
          const x1 = calculateStep(1);
          const x2 = element.nsides.left;
                   shapes.push(createLine(x1, element.nsides.top, x2, element.nsides.top));
          shapes.push(createLine(x1, element.nsides.bottom, x2, element.nsides.bottom));
        }
        // Vertical measurement line
        {
          const x = calculateStep(1, true);
          const y1 = element.nsides.bottom;
          const y2 = element.nsides.top;
                   shapes.push(createMeasurementLine(x, y1, x, y2, true, true));
          shapes.push(createText(x, getCenter(y1, y2), element.scale.y, true));
        }
      }
      */
      // Fastenings...

      if (element.elements) {
        var fastenings = element.elements.filter(function (e) {
          return e.type === 'fastening';
        }) || [];

        if (fastenings.length > 0) {
          var topLeft = fastenings[0];
          var topRight = fastenings[1];
          var bottomLeft = fastenings[2];
          var bottomRight = fastenings[3]; // Crosses

          fastenings.forEach(function (fastening, index) {
            shapes.push(shapes_base_1.createLine(fastening.nposition.x - 10, fastening.nposition.y, fastening.nposition.x + 10, fastening.nposition.y));
            shapes.push(shapes_base_1.createLine(fastening.nposition.x, fastening.nposition.y - 10, fastening.nposition.x, fastening.nposition.y + 10));
          }); // Measurement for top 2...

          {
            var y1 = topLeft.nposition.y;
            var y2 = utils_1.calculateStep(4);
            shapes.push(shapes_base_1.createLine(topLeft.nposition.x, y1, topLeft.nposition.x, y2));
            shapes.push(shapes_base_1.createLine(topRight.nposition.x, y1, topRight.nposition.x, y2));
          } // Horizontal width line for cut-out

          {
            var y = utils_1.calculateStep(4, true);
            var x1 = topLeft.nposition.x;
            var x2 = topRight.nposition.x;
            shapes.push(shapes_base_1.createMeasurementLine(x1, y, x2, y, false));
            shapes.push(shapes_base_1.createText(utils_1.getCenter(x1, x2), y, topRight.position.x - topLeft.position.x));
          } // Measurement for left 2...

          {
            var x1 = topLeft.nposition.x;
            var x2 = plate.nsides.left - utils_1.calculateStep(1, true);
            shapes.push(shapes_base_1.createLine(x1, topLeft.nposition.y, x2, topLeft.nposition.y));
            shapes.push(shapes_base_1.createLine(x1, bottomLeft.nposition.y, x2, bottomLeft.nposition.y));
          } // Vertical measurement

          {
            var x = plate.nsides.left - utils_1.calculateStep(1);
            var y1 = bottomLeft.nposition.y;
            var y2 = topLeft.nposition.y;
            shapes.push(shapes_base_1.createMeasurementLine(x, y1, x, y2, true));
            shapes.push(shapes_base_1.createText(x, utils_1.getCenter(y1, y2), bottomLeft.position.y - topLeft.position.y, true));
          } // Measurement for bottom 2...

          {
            var x1 = bottomRight.nposition.x;
            var x2 = plate.nsides.left - utils_1.calculateStep(1, true);
            shapes.push(shapes_base_1.createLine(x1, bottomRight.nposition.y, x2, bottomRight.nposition.y));
            shapes.push(shapes_base_1.createLine(x1, plate.nsides.bottom, x2, plate.nsides.bottom));
          }
          {
            var x = plate.nsides.left - utils_1.calculateStep(1);
            var y1 = plate.nsides.bottom;
            var y2 = bottomRight.nposition.y;
            shapes.push(shapes_base_1.createMeasurementLine(x, y1, x, y2, true, true));
            shapes.push(shapes_base_1.createText(x, utils_1.getCenter(y1, y2), plate.sides.bottom - bottomRight.position.y, true));
          } // Fastening info

          {
            var x1 = bottomRight.nposition.x;
            var y1 = bottomRight.nposition.y;
            var x2 = plate.nsides.right + config_1.config.explodedTextSpace;
            var y2 = plate.nsides.bottom + 55;
            var textLines = [translations_1.default.translate('Part.SocketM6x4')];

            if (trash) {
              if (trash.subType === 'rail_150_withcosmetic') {
                textLines.push(translations_1.default.translate('Part.ZANMW0044'));
                textLines.push(translations_1.default.translate('#2030055226'));
              } else if (trash.subType === 'rail_150') {
                textLines.push(translations_1.default.translate('Part.ZANMW0043'));
                textLines.push(translations_1.default.translate('#2030053539'));
              } else if (trash.subType === 'rail_60') {
                textLines.push(translations_1.default.translate('Part.ZANMW0042'));
                textLines.push(translations_1.default.translate('#2030053538'));
              }

              shapes.push(shapes_base_1.createExplodedText(x1, y1, x2, y2, textLines));
            }
          }
        }
      }
    }
  });
  return shapes;
};

var angleOfNiches = function angleOfNiches(elements) {
  var shapes = [];
  elements.forEach(function (element) {
    if (element.type !== 'wall') {
      return;
    } // Starting trying to break it out into other methods, but having a hard time figuring out how to get the context etc into the function...


    var x = element.nposition.x;
    var y = element.nsides.top;
    var side = element.isLast ? 'right' : 'left'; // const width = 80;

    var arcWidth = 50;
    var arcX = x + (side === 'right' ? -config_1.config.shapes.arrowSize : config_1.config.shapes.arrowSize);
    var arcY = y + config_1.config.shapes.arrowSize;
    var arcStart = 90 + (side === 'right' ? 90 : 0);
    var arcEnd = 180 + (side === 'right' ? 90 : 0);
    var textAnchor = side === 'right' ? 'end' : 'start';
    shapes.push(shapes_base_1.createArc(arcX, arcY, arcWidth, arcStart, arcEnd));
    shapes.push(shapes_base_1.createText(arcX, arcY + config_1.config.text.space, element.rotate.y + '°', false, textAnchor));
    var upperArrowX = arcX + (side === 'right' ? -arcWidth : arcWidth);
    var upperArrowY = arcY - 10;
    var upperArrowAngle = 90;
    shapes.push(shapes_base_1.createArrow(upperArrowX, upperArrowY, upperArrowAngle, true));
    var lowerArrowX = arcX + (side === 'right' ? 10 : -10);
    var lowerArrowY = arcY + arcWidth;
    var lowerArrowAngle = side === 'right' ? 180 : 0;
    shapes.push(shapes_base_1.createArrow(lowerArrowX, lowerArrowY, lowerArrowAngle, true)); // Lower arrow
  });
  return shapes;
};